var TooltipTrigger;
(function (TooltipTrigger) {
    TooltipTrigger["ELLIPSIS"] = "ellipsis";
    TooltipTrigger["FOCUS"] = "focus";
    TooltipTrigger["HOVER"] = "hover";
})(TooltipTrigger || (TooltipTrigger = {}));
export { TooltipTrigger, };
//# sourceMappingURL=tooltip-constants.js.map